import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale, FOOTER_HEIGHT } from '@/theme';
import { mq } from '@/theme/scalingTokens';

const footerBodyText = {
  color: tokens.colorNeutralForeground1,
  fontSize: fontScale.caption,
} as const;

const NARROW_VIEWPORT = '@media (max-width: 639px)';

export const useFooterStyles = makeStyles({
  root: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    height: FOOTER_HEIGHT,
    boxSizing: 'border-box',
    backgroundColor: tokens.colorNeutralBackground2,
    borderTopWidth: '0.0625rem',
    borderTopStyle: 'solid',
    borderTopColor: tokens.colorNeutralStroke1,
    ...shorthands.padding(0, tokens.spacingHorizontalXXL),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    ...shorthands.gap(tokens.spacingHorizontalM),
    zIndex: 100,
    [NARROW_VIEWPORT]: {
      ...shorthands.padding(0, tokens.spacingHorizontalM),
    },
    [mq.highZoom]: {
      position: 'static' as const,
      zIndex: 'auto',
    },
  },
  privacyLinks: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'nowrap',
    minWidth: 0,
    ...shorthands.gap(tokens.spacingHorizontalM),
  },
  link: {
    color: tokens.colorBrandForegroundLink,
    textDecorationLine: 'underline',
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightSemibold,
    whiteSpace: 'nowrap',
    ':hover': {
      color: tokens.colorBrandForegroundLinkHover,
      textDecorationLine: 'underline',
    },
    ':focus-visible': {
      outlineWidth: '0.125rem',
      outlineStyle: 'solid',
      outlineColor: tokens.colorStrokeFocus2,
      outlineOffset: '0.125rem',
      borderRadius: tokens.borderRadiusSmall,
    },
  },
  copyrightFull: {
    ...footerBodyText,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    [NARROW_VIEWPORT]: {
      display: 'none',
    },
  },
  copyrightShort: {
    ...footerBodyText,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    display: 'none',
    [NARROW_VIEWPORT]: {
      display: 'inline',
    },
  },
});
